import {setCookie} from "@js/globalFunctions/cookieHandling";

export function defineCurrentSearchByRequestHeaders( request )
{
	var currentSearch = request.getResponseHeader('x-esbs-oldpfp');
	if( typeof currentSearch !== 'undefined' )
	{
		setCookie('esbsoldpfp',currentSearch,1);
	}
}

export function defineCurrentGenericSearchFileByRequestHeaders( request )
{
	var currentGenericFile = request.getResponseHeader('x-esbs-returnname');
	if( typeof currentGenericFile !== 'undefined' )
	{
		setCookie('genericSearchFile',currentGenericFile,1);
	}
}
